// extracted by mini-css-extract-plugin
export default {"app":"App_app__zr1wm","main":"App_main__nhgh3","hero":"App_hero__eey18","catalog":"App_catalog__khOCx","footer":"App_footer__aawhi"};